import * as React from "react";


import "./AdminOffer.scss";
import {Box, Card, IconButton} from "@mui/material";

import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import HoverBox from "components/HoverBox";
import LazyImage from "components/LazyImage";
import { H4 } from "components/Typography";
import {getImageOrLogo, getLocalDate} from "helpers/utils";
import {DATE_FORMAT, DATE_TIME_FORMAT_SHORT} from "config/constants";
import {H2, H5} from "../../../../CustomTypography";


const AdminOffer = (props) => {
  const { offer = {}, userDetails, editCategorySettings, className = "" } = props;
  const { id, name, images = [], is_popular, is_active, store_entry } = offer;

  return (

      <Box pb={2}>
        <HoverBox  mb={0} mx="auto" borderRadius="2px" onClick={editCategorySettings}>
          <LazyImage
              src={getImageOrLogo(offer.images, offer.logo)}
              width={150}
              height={150}
              alt={offer.name}
              mx="auto"
          />
        </HoverBox>
          <H2 textTransform="uppercase" fontSize={12} textAlign="left" title={offer.title} ellipsis>
              {offer.name}
          </H2>
        <H5 fontSize={12} textAlign="left" title={offer.name} ellipsis>
            {offer.title}
        </H5>
          <H5 fontSize={12} textAlign="left" ellipsis>
              {offer.is_offer_active === true ? "Active" : "Inactive"} {getLocalDate(offer.offer_created_at, DATE_TIME_FORMAT_SHORT)}
          </H5>
          <H5 fontSize={12} textAlign="left" ellipsis>
              {offer.user_id && offer.user_id.name}
          </H5>
          <Box display="flex">
              <IconButton  className="setting-button" color="primary" size="small" onClick={editCategorySettings}>
                  <MoreHorizIcon />
              </IconButton>
          </Box>
      </Box>
  );
};

export default AdminOffer;
